import { useCallback, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import { ImageRegistration } from '~/domain/patient/patient';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';

import {
    blendImageState,
    primaryImageState,
    selectedRegistrationState,
} from '~/state/atoms/image/imageAtoms';
import useSelectedPatient from '../patient/useSelectedPatient';
import useViewportEnvironment from '../useViewportEnvironment';

export default function useBlendableImage() {
    const [blendableImages, setBlendableImages] = useState<ImageRegistration[]>(
        []
    );

    const patient = useSelectedPatient();
    const blendedImage = useRecoilValue(blendImageState);
    const primaryImage = useRecoilValue(primaryImageState);
    const [selectedRegistration, setSelectedRegistration] = useRecoilState(
        selectedRegistrationState
    );
    const { setEnvironmentBlendImage } = useViewportEnvironment();

    useEffect(() => {
        if (primaryImage) {
            const images = patient
                ?.getBlendableImages(primaryImage)
                .filter(
                    (registration) =>
                        registration.image.dicomUid !== blendedImage?.dicomUid
                );
            images && setBlendableImages(images);
        }
    }, [patient, primaryImage, blendedImage, selectedRegistration]);

    const handleChangeBlendedImage = useCallback(
        (image: Image3D, registration: RigidRegistration | undefined) => {
            const imageAvailable = patient?.images?.includes(image);
            if (patient && imageAvailable) {
                setSelectedRegistration(registration);
                setEnvironmentBlendImage(image, registration);
            }
        },
        [patient, blendableImages]
    );

    return { blendedImage, blendableImages, handleChangeBlendedImage };
}
